import { call, put } from 'redux-saga/effects'
import { patchMemberProfile, getMemberProfileHiringTeams } from '../apiModules/memberProfiles'
import { hiringTeamEntities, memberProfileEntities } from '../reducks'

export function* updateMemberProfileEntitySaga(memberProfileId, data) {
  const response = yield call(patchMemberProfile, memberProfileId, data)
  yield put(memberProfileEntities.updateItem(memberProfileId, response.result))
  return response
}

export function* fetchMemberProfileHiringTeamEntitiesSaga(memberProfileId) {
  const response = yield call(getMemberProfileHiringTeams, memberProfileId)

  if (response.result.length > 0) {
    yield put(hiringTeamEntities.addCollection(response.result))
  }

  return response
}
